// 使用新的埋点规范，参考http://112.124.122.87:8090/pages/viewpage.action?pageId=6554041
import Stat from '@/frontend-lib/lib/stat/Stat.js'
import {
  getPlatform
} from '@/frontend-lib/tools/getPlatform'
import { GetQueryString, getHashParameters } from '@/lib/units'
const { isYixinliApp } = getPlatform()
const channelId = getHashParameters()['channelId'] || GetQueryString('channelId') 

let platform = 'cp'
if (+channelId === 513) platform = 'msite'
if (isYixinliApp) platform = 'yxlApp'

const cpStat = new Stat({platform}) 

// 页面访问
function visit({
  category,
  eventValue,
  extraAttr
}) {
  cpStat.visit({
    businessType: '测评', // 事件所属业务
    category, // 产品
    eventValue, // 主要属性值
    extraAttr // 额外属性
  })
}

// 交互行为
function interact({
  category,
  eventValue,
  pageTitle,
  extraAttr
}) {
  cpStat.interact({
    businessType: '测评', // 事件所属业务
    category, // 产品
    eventValue, // 主要属性值
    pageTitle,
    extraAttr // 额外属性
  })
}

// 社交行为
function social({
  category,
  eventValue,
  eventAttribute='对象',
  pageTitle,
  extraAttr
}) {
  cpStat.social({
    businessType: '测评', // 事件所属业务
    category, // 产品
    eventAttribute, // 主要事件属性
    eventValue, // 主要属性值
    pageTitle, // 页面title
    extraAttr
  })
}

export default {
  visit,
  interact,
  social
}


// WEBPACK FOOTER //
// ./src/lib/track.js